// AddReviewerGroupForm.jsx
import React, { useEffect } from 'react';
import { Form, Input, Select, Button } from 'antd';
import { SubmitButton, SubmitButtonCol } from '../styledComponents';
const { Option } = Select;

const AddReviewerGroupForm = ({
  reviewers,
  selectedItem,
  submitHandler,
  submitLoading
}) => {
  const [form] = Form.useForm();

  const onFinish = values => {
    submitHandler(values);
  };
  // const setFormValues = item => {
  //     const data = item;
  //     data.dob = moment(data.dob);
  //     data.phoneNumber.number = data.phoneNumber.countryCode.concat(
  //       data.phoneNumber.number
  //     );
  //     data.facilityIds = data.facilities.map(val => val.facilityId);
  //     console.log(item, data, 'fatr');

  //     form.setFieldsValue({ ...data });
  //     setchangedValues({ ...data });
  //   };
  useEffect(() => {
    if (selectedItem) {
    }
    // eslint-disable-next-line
  }, [selectedItem]);
  return (
    <Form
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={{
        ...selectedItem,
        reviewerIds: selectedItem?.reviewers?.map(reviewer => reviewer.id) || []
      }}
    >
      <Form.Item
        label='Group Name'
        name='groupName'
        rules={[{ required: true, message: 'Please enter group name' }]}
      >
        <Input placeholder='Enter group name' size='large' />
      </Form.Item>

      <Form.Item
        label='Reviewers'
        name='reviewerIds'
        rules={[
          { required: true, message: 'Please select at least one reviewer' }
        ]}
      >
        <Select
          size='large'
          mode='multiple'
          placeholder='Select reviewers'
          optionFilterProp='children'
          showSearch
        >
          {reviewers.map(user => (
            <Option key={user.id} value={user.id}>
              {user.fullName}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label='Levels'
        name='level'
        rules={[{ required: true, message: 'Please select level' }]}
      >
        <Select placeholder='Select level' size='large'>
          <Option value='LEVEL_1'>Level 1</Option>
          <Option value='LEVEL_2'>Level 2</Option>
          <Option value='ALL_LEVELS'>All Levels</Option>
        </Select>
      </Form.Item>

      <SubmitButtonCol span={24}>
        <SubmitButton
          htmlType='submit'
          type='primary'
          size='large'
          shape='round'
          loading={submitLoading}
        >
          Submit
        </SubmitButton>
      </SubmitButtonCol>
    </Form>
  );
};

export default AddReviewerGroupForm;
